import { formatDistanceToNow } from 'date-fns';
import { enUS } from 'date-fns/locale';

const customLocale = {
  ...enUS,
  formatDistance: (...args: Parameters<typeof enUS.formatDistance>) => {
    const result = enUS.formatDistance(...args);
    return result
      .replace(/^about /, '')
      .replace(/^over /, '')
      .replace(/^almost /, '');
  },
};

export const formatTimeAgo = (dateString: string): string => {
  const date = new Date(dateString);
  const diffInMs = Date.now() - date.getTime();

  if (diffInMs > 1000 * 60 * 60 * 24 && diffInMs < 1000 * 60 * 60 * 48) {
    return 'yesterday';
  }

  return formatDistanceToNow(date, {
    addSuffix: true,
    locale: customLocale,
  });
};

export const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  // Use explicit formatting to avoid hydration issues
  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  
  const month = months[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();
  
  return `${month} ${day}, ${year}`;
};

export const formatRelativeDate = (dateString: string) => {
  const date = new Date(dateString);
  const now = new Date();
  const diffInMs = now.getTime() - date.getTime();
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

  if (diffInDays === 0) {
    return 'Today';
  } else if (diffInDays === 1) {
    return 'Yesterday';
  } else if (diffInDays < 7) {
    return `${diffInDays} days ago`;
  } else {
    return formatDate(dateString);
  }
};
